export default __webpack_public_path__ + "static/media/account.17287408.svg";